import { Card, CardContent } from '@/components/ui-kit/card';
// import Image from "next/image";
import { ToolsCardDropDown } from './tools-card-dropdown';
import { ToolCardData } from '@/modules/gpt-chats/types/tools.service.type';
import { useTranslation } from 'react-i18next';

export const ToolsCardGridView = ({
  tool,
  copiedBlocksTool,
}: {
  tool: ToolCardData;
  copiedBlocksTool: boolean;
}) => {
  const { t } = useTranslation();
  const toolTypeLabel = tool.toolType.startsWith('mcp') ? t('MCP_TAB') : t('TOOL_TAB');

  return (
    <Card className="group flex h-[160px] flex-1 flex-col items-start rounded-lg border-border/40 bg-card p-4 shadow-sm transition-all duration-200 hover:border-border hover:bg-accent/5 hover:shadow-md">
      <CardContent className="flex w-full flex-col items-start gap-3 p-0">
        <div className="flex w-full items-start justify-between gap-3">
          <div className="flex min-w-0 flex-1 items-start gap-4">
            {/* <div className="relative h-16 w-16 flex-shrink-0 overflow-hidden rounded-lg">
              {tool.logo_url ? (
                <Image src={tool.logo_url} fill={true} alt="agent_logo" className="object-cover" />
              ) : (
                <div className="flex h-full w-full items-center justify-center bg-muted"></div>
              )}
            </div> */}

            <div className="flex min-w-0 flex-col items-start gap-1.5">
              <h3
                className="text-lg font-semibold leading-tight text-foreground"
                title={tool?.name}
              >
                {tool?.name}
              </h3>
              <span className="w-fit rounded-md bg-muted px-2.5 py-0.5 text-xs font-medium text-muted-foreground">
                {toolTypeLabel}
              </span>
            </div>
          </div>

          <div
            className="flex-shrink-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <ToolsCardDropDown tool={tool} copiedBlocksTool={copiedBlocksTool} />
          </div>
        </div>

        <p
          className="line-clamp-2 text-sm leading-relaxed text-muted-foreground"
          title={tool?.description}
        >
          {tool?.description}
        </p>
      </CardContent>
    </Card>
  );
};
